<i2a-profile-alert-base-modal
  [manualDescriptionKey]="'applyCorrection.providers.microsoft.sharePoint.permission.external.manual.description'"
  [manualLinkKey]="'applyCorrection.providers.microsoft.sharePoint.permission.external.manual.link'"
  [automaticDescriptionKey]="'applyCorrection.providers.microsoft.sharePoint.permission.external.automatic.description'"
  [ignoreCommentToSend]="session.IgnoreCommentToSend" [displayComment]="session.DisplayComment"
  [validation]="validation" [canSend]="canSend"
  [modalTitle]="'profile.provider.microsoft.sharePoint.confirmationOfInformationTitle.permissions' | i18next"
  [informationKey]="informationKey" [activateFullScreen]="true" [resourceProfile]="resourceProfile">

  <ng-container header-picto>
    <i2a-badge-icon>
      <ng-container icon>
        <fa-icon [icon]="['fas', 'users']" size="lg"></fa-icon>
      </ng-container>
    </i2a-badge-icon>
  </ng-container>

  <ng-container header-title>
    {{'profile.provider.microsoft.sharePoint.external' | i18next}}<br>
  </ng-container>

  <ng-container body>
    <div class="container-fluid">
      <div class="row pt-3">
        <div class="col-12">

          <div class="form-group delegate-container">
            <table class="table-sm id-table mt-2">
              <tbody>
                <tr>
                  <td scope="row text-center" class="cell-checkbox">
                    <i2a-input-checkbox [(model)]="allAccounts" (modelChange)="allAccountsChecked($event)"
                      [classNameChecked]="'btn-outline-danger'" [className]="'btn-outline-dark'" [valueChecked]="true"
                      [valueUnChecked]="false">
                    </i2a-input-checkbox>
                  </td>
                  <td scope="row" class="text-break w-100 delegate-title">
                    {{'profile.provider.microsoft.sharePoint.allAccounts' |i18next}}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row pt-3" *ngIf="validation && validation.permissions">
        <ng-container *ngFor="let delegateValidation of validation.permissions; let i = index">
          <div class="col-12">

            <i2a-share-point-permission-form [(validation)]="validation.permissions[i]"
              [driveItemsPermissions]="getPaths(delegateValidation.permissions.logonUserId)" (setCanSend)="setCanSend()"
              [allPathsTitle]="delegateValidation.permissions.name" [pathCollapsed]="true">
            </i2a-share-point-permission-form>

          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  
  <ng-container message>
    <div class="row pt-3" *ngIf="hasSpecificLink">
      <div class="col-12">
        <i2a-message>
          <ng-container message-content>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 13.125 13.125"
            style="vertical-align: sub;margin-right: 5px;">
            <path
              d="M363.563,108.875L357,122h13.125Zm0.437,5.25V118.5h-0.875v-4.375H364Zm-0.875,5.25H364v0.875h-0.875v-0.875Z"
              fill="#ffcf64" transform="translate(-357 -108.875)" /></svg>

        {{'profile.provider.microsoft.sharePoint.specificLinkWarning' | i18next}}
          </ng-container>
        </i2a-message>
      </div>
    </div>
  </ng-container>
</i2a-profile-alert-base-modal>